import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import TermsGate from "@/components/TermsGate";
import Login from "@/pages/Login";
import AdminDashboard from "@/pages/Dashboard";
import CompanyDashboard from "@/pages/CompanyDashboard";
import Empresas from "@/pages/Empresas";
import Empleados from "@/pages/Empleados";
import Adelantos from "@/pages/Adelantos";
import Liquidaciones from "@/pages/Liquidaciones";
import Reportes from "@/pages/Reportes";

function DashboardRoute() {
  const { user } = useAuth();
  return user?.role === "admin" ? <AdminDashboard /> : <CompanyDashboard />;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              element={
                <ProtectedRoute>
                  <TermsGate>
                    <Layout />
                  </TermsGate>
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<DashboardRoute />} />
              <Route path="/empresas" element={<ProtectedRoute adminOnly><Empresas /></ProtectedRoute>} />
              <Route path="/empleados" element={<Empleados />} />
              <Route path="/adelantos" element={<Adelantos />} />
              <Route path="/liquidaciones" element={<ProtectedRoute adminOnly><Liquidaciones /></ProtectedRoute>} />
              <Route path="/reportes" element={<ProtectedRoute adminOnly><Reportes /></ProtectedRoute>} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
